export default function blockStyleMap(contentBlock) {
  const type = contentBlock.getType();
  if (type === 'LEFT') {
    return 'leftAlignmentStyles';
  } else if (type === 'RIGHT') {
    return 'rightAlignmentStyles';
  } else if (type === 'CENTER') {
    return 'centerAlignmentStyles';
  } else if (type === 'JUSTIFY') {
    return 'justifyAlignmentStyles';
  } else if (type === 'QUOTE') {
    return 'quoteStyles';
  }
  return null;
}
